/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import http from "../http-common";

const controller = "/component";
const componentService = {
    getall: async () => {
        const response = await http.get(`${controller}`);
        return response.data;
    }
};
export default componentService;